var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.056,
    height: 30.544,
    viewBox: "0 0 29.056 30.544",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3189",
    "data-name": "Group 3189",
    transform: "translate(-7.197 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1884",
    "data-name": "Path 1884",
    d: "M33.353,38.809a1.391,1.391,0,0,0,1.391-1.391v-1.19c0-1.68-.122-4.334-.167-5.267a.356.356,0,0,0-.357-.339H34.2a.357.357,0,0,0-.357.357h0v4.872a.37.37,0,0,1-.3.372.358.358,0,0,1-.412-.293.351.351,0,0,1-.005-.059V31a.371.371,0,0,0-.3-.372.358.358,0,0,0-.412.293.353.353,0,0,0-.005.06v4.872a.37.37,0,0,1-.3.372.358.358,0,0,1-.412-.293.35.35,0,0,1-.005-.059V31a.371.371,0,0,0-.3-.372.358.358,0,0,0-.412.293.352.352,0,0,0-.005.06v4.872a.37.37,0,0,1-.3.372.358.358,0,0,1-.412-.293.352.352,0,0,1-.005-.06V30.979a.357.357,0,0,0-.357-.357H29.9a.356.356,0,0,0-.357.339c-.045.934-.167,3.587-.167,5.267v1.19a1.391,1.391,0,0,0,1.391,1.391h0a.494.494,0,0,1,.484.4c.325,1.663.242,3.762-.594,11.519a1.437,1.437,0,1,0,2.809,0c-.836-7.756-.919-9.856-.594-11.519A.494.494,0,0,1,33.353,38.809Z",
    transform: "translate(-14.65 -16.926)",
    fill: "#121e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1885",
    "data-name": "Path 1885",
    d: "M46.222,80.762a11.314,11.314,0,0,1-1.941-.17c.09.893.194,1.89.315,3.011.011.1.013.2.016.3a14.669,14.669,0,0,0,1.61.091c.408,0,.81-.021,1.209-.054a16.013,16.013,0,0,1,.119-3.255A11.362,11.362,0,0,1,46.222,80.762Z",
    transform: "translate(-24.499 -49.938)",
    fill: "#121e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1886",
    "data-name": "Path 1886",
    d: "M21.723,5a14.527,14.527,0,0,0-6.861,27.332c.146-1.392.263-2.571.355-3.577a11.3,11.3,0,1,1,12.871.1l.015.13c.149,1.327.277,2.484.33,3.425A14.526,14.526,0,0,0,21.723,5Z",
    transform: "translate(0 0)",
    fill: "#121e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1887",
    "data-name": "Path 1887",
    d: "M55.853,41.79c.171-2.179-1.735-.4-1.8-3.394-.087-4.084.824-8.7,3.14-9.459.25-.083.462-.062.471.358L58.1,49.736c.017.772-.274,1.485-1.309,1.507-1.14.024-1.627-.638-1.564-1.446Z",
    transform: "translate(-30.951 -15.788)",
    fill: "#121e59"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMain);
export default __webpack_public_path__ + "static/media/main.5db36849e21974134df50d3c8cdb3051.svg";
export { ForwardRef as ReactComponent };